import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faTrashAlt,
  faExternalLinkAlt,
  faCheck,
  faSpinner,
  faTimes,
  faHistory,
  faList,
  faMinus,
  faForward,
  faBackward,
  faCopy,
  faMagic,
  faInfoCircle,
  faExclamationCircle,
  faArrowRight,
  faWandMagicSparkles,
  faMagnifyingGlass,
  faChevronUp,
  faChevronDown,
  faCircle,
  faExclamationTriangle,
  faBold,
  faItalic,
  faStrikethrough,
  faSuperscript,
  faSubscript,
  faUnderline,
  faCode,
  faLink,
  faParagraph,
  faListUl,
  faListOl,
  faUndo,
  faRedo,
  faSquareRootAlt,
  faGripVertical,
  faEye,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faBars,
  faTrashAlt,
  faExternalLinkAlt,
  faCheck,
  faSpinner,
  faTimes,
  faHistory,
  faList,
  faMinus,
  faForward,
  faBackward,
  faCopy,
  faMagic,
  faInfoCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faArrowRight,
  faWandMagicSparkles,
  faMagnifyingGlass,
  faChevronUp,
  faChevronDown,
  faCircle,
  faBold,
  faItalic,
  faStrikethrough,
  faSuperscript,
  faSubscript,
  faUnderline,
  faCode,
  faLink,
  faParagraph,
  faListUl,
  faListOl,
  faUndo,
  faRedo,
  faSquareRootAlt,
  faGripVertical,
  faEye,
);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
